import React, { useState, useEffect } from 'react';
import { Col, Row, Input, Label } from 'reactstrap';
import { TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab'


// Redux
import { connect } from 'react-redux';

//Componentes
import CustomModal from '../../../components/modales/customModal';

//API Calls
const { apiListadoGerencias } = require('../../../utils/APIs/APISResume')

const mapStateToProps = state => ({
    usuarioActivo: state
})

const ModalExportacionAPE = (props) => {
    let todayDate = new Date(Date.now())
    const [startDate, setStartDate] = useState(`${todayDate.getFullYear()}-${todayDate.getMonth() - 1}-${todayDate.getDate()}`)
    const [endDate, setEndDate] = useState(`${todayDate.getFullYear()}-${todayDate.getMonth()}-${todayDate.getDate()}`)
    const [ok, setOk] = useState(true)
    const [userData] = useState(JSON.parse(localStorage.getItem('userData')));
    const [gerencia, setGerencia] = useState(userData.gerencia)
    const [gerencias, setGerencias] = useState([])

    useEffect(() => {
        const getGerencias = async () => {
            const tempGerencias = await apiListadoGerencias({
                cod_empr:537
            })
            setGerencias(['Todos', ...tempGerencias])
        }
        getGerencias()
    }, [])

    return (
        <React.Fragment>
            <CustomModal
                modal={props.modal}
                toggle={() => props.toggle()}
                title={'Exportar Reporte'}
                buttonTitle={'Exportar'}
                // enableOk={ok && startDate.getTime() < endDate.getTime()}
                onClick={() => props.action({ start: startDate, end: endDate, gerencia: gerencia })}
            // buttonLoading={cancelando}
            >
                <Row>
                    <Col lg='4' md='4' xs="12">
                        {!userData.roles.includes('administrador')?<TextField
                            required
                            key={`key_Gerencia`}
                            id={`input_Gerencia`}
                            fullWidth
                            label='Gerencia'
                            defaultValue={`${userData.gerencia}`}
                            margin="normal"
                            disabled
                        />:
                            <Autocomplete
                                required
                                margin="dense"
                                options={gerencias}
                                key={`key_TipoDeContrato`}
                                id={`select_TipoDeContrato`}
                                onChange={(event, newValue) => setGerencia(newValue)}
                                renderInput={(params) => (
                                    <TextField {...params} label={'CONTRATO'} margin="normal" />
                                )}
                                getOptionLabel={(option) => option}
                                renderOption={(option) => (
                                    <React.Fragment>
                                        {option}
                                    </React.Fragment>
                                )}
                            />}
                    </Col>
                    <Col lg='4' md='4' xs="12" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center' }}>
                        <Label for="exampleSelect">Fecha de Inicio</Label>
                        <input
                            id="startDate"
                            name="date"
                            value={startDate ? startDate: new Date(Date.now()).toISOString().split('T')[0]}
                            onChange={(e) => {
                                setStartDate(e.target.value)
                            }}
                            type="date"
                        />
                    </Col>
                    <Col lg='4' md='4' xs="12" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center' }}>
                        <Label for="exampleSelect">Fecha de Fin</Label>
                        <input
                            id="endDate"
                            name="datetime"
                            value={endDate ? endDate : new Date(Date.now().getTime() + 86400000).toISOString().split('T')[0]}
                            onChange={(e) => { setEndDate(e.target.value) }}
                            type="date"
                        />
                    </Col>
                </Row>
            </CustomModal>
        </React.Fragment>
    );
}

export default connect(mapStateToProps)(ModalExportacionAPE);